// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"283": "68fd5b39","366": "9154912f","851": "9ba50c2e","985": "482cb750",}[chunkId] + ".css"
}